import React from 'react';
import {MenuItem, Select} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

const CashiersList = () => {
    const [add, setAdd] = React.useState(false);

    return (
        <div style={{padding: 20}}>
            <div style={{marginBottom: 12, width: '100%', background: '#1b2039', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 0'}}>
                <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18}}>Кассиры</span>
            </div>
            <div style={{marginBottom: 12, width: '100%', background: '#1b2039', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                <Select fullWidth value={'Любовь'} style={{
                    color: '#fff',
                    padding: '5px 20px'
                }}>
                    <MenuItem value={'Любовь'}>Любовь</MenuItem>
                    <MenuItem value={'Снежинка'}>Снежинка</MenuItem>
                    <MenuItem value={'Снежинка'}>Радуга</MenuItem>
                    <MenuItem value={'Снежинка'}>Пантера</MenuItem>
                </Select>
            </div>
            <div style={{marginBottom: 12, width: '100%', background: '#1b2039', borderRadius: 8, display: 'flex', alignItems: 'center', flexDirection: 'column', padding: '10px 0',}}>
                <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18, borderBottom: '1px solid rgba(0,0,0,.3)', width: '100%', textAlign: 'center', paddingBottom: 12}}>
                    Любовь (Ю)
                </span>
                <div style={{marginTop: 12, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center'}}>
                    <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 16, width: '80%', border: '1px solid rgba(255,255,255,.7)', textAlign: 'center', padding: 10, marginBottom: 8, borderRadius: 8}}>
                        Изменить букву
                    </span>
                    <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 16, width: '80%', border: '1px solid rgba(255,255,255,.7)', textAlign: 'center', padding: 10, marginBottom: 8, borderRadius: 8}}>
                        Изменить пароль
                    </span>
                    <span style={{color: 'red', fontFamily: 'Montserrat, sans-serif', fontSize: 16, width: '80%', border: '1px solid red', textAlign: 'center', padding: 10, marginBottom: 8, borderRadius: 8}}>
                        Заблокировать
                    </span>
                </div>
            </div>
            <div style={{position: 'absolute', bottom: 20, right: 20}}>
                <div style={{position: 'relative'}}>
                    <Fab color="primary" aria-label="add" style={{width: 100, height: 100}} onClick={() => setAdd(true)}>
                        <AddIcon /> 
                    </Fab>
                    {
                        add &&
                        <div style={{position: 'absolute', top: 0, left: -100, zIndex: 100, background: '#fff', borderRadius: 8}}>
                            <MenuItem value={'Добавить группу'} onClick={() => setAdd(false)}>Добавить группу</MenuItem>
                            <MenuItem value={'Добавить кассира'}  onClick={() => setAdd(false)}>Добавить кассира</MenuItem>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default CashiersList;